/* eslint-disable react/no-string-refs */
import {IHeaderParams} from "@ag-grid-community/core";
import {Tooltip} from "@blueprintjs/core";
import {Manifest} from "../../../../generated/graphql";
import {ManifestDetailsContext} from "../ManifestDetailsV2";
import {isNumber} from "lodash";
import {WarningIcon} from "../../../common/icons";
import {useShiftPressed} from "../../../../hooks/useShiftPressed";

export interface JobColHeaderRendererParams extends IHeaderParams<Manifest, ManifestDetailsContext> {
  jobColoringIndex: Map<string, number>;
  stopLength: number;
}

const JobColHeaderRenderer = ({
  jobColoringIndex,
  stopLength,
  progressSort,
  column,
  showColumnMenu,
  eGridHeader,
  columnApi,
  enableMenu
}: JobColHeaderRendererParams) => {
  const isShiftKeyPressed = useShiftPressed();
  const sortDirection = column.getSort();
  const sortIndex = column.getSortIndex();
  const isFilterActive = column.isFilterActive();
  const showSortOrder = columnApi.getColumnState().filter((col) => col.sort != null).length > 1;

  const handleShowFilter = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation();
    showColumnMenu(eGridHeader);
  };

  return (
    <div
      className="ag-cell-label-container ag-header-cell-sorted-none"
      onClick={() => progressSort(isShiftKeyPressed)}
      aria-hidden="true"
    >
      <span
        data-testid="filter-icon"
        className={`ag-header-icon ag-header-cell-menu-button ${enableMenu ? "" : "ag-hidden"}`}
        onClick={handleShowFilter}
        aria-hidden="true"
      >
        <span className="ag-icon ag-icon-menu"></span>
      </span>
      <div className="ag-header-cell-label">
        <span className="ag-header-cell-text">JOB #</span>
        <span style={{marginLeft: "4px"}}>
          {jobColoringIndex.size === 0 && stopLength > 0 && (
            <Tooltip
              content={"Unique colors for each Job are only possible when there are 20 or less Jobs in the manifest."}
              popoverClassName="manifest-header-warning-tooltip"
              placement="top"
            >
              <WarningIcon />
            </Tooltip>
          )}
        </span>
        <span className={`ag-header-icon ag-header-label-icon ag-filter-icon ${isFilterActive ? "" : "ag-hidden"}`}>
          <span className="ag-icon ag-icon-filter"></span>
        </span>
        <span className="ag-sort-indicator-container">
          <span className={`ag-sort-indicator-icon ag-sort-order ${showSortOrder ? "" : "ag-hidden"}`}>
            {isNumber(sortIndex) ? sortIndex + 1 : ""}
          </span>
          <span
            className={`ag-sort-indicator-icon ag-sort-ascending-icon ${sortDirection === "asc" ? "" : "ag-hidden"}`}
          >
            <span className="ag-icon ag-icon-asc"></span>
          </span>
          <span
            className={`ag-sort-indicator-icon ag-sort-descending-icon ${sortDirection === "desc" ? "" : "ag-hidden"}`}
          >
            <span className="ag-icon ag-icon-desc"></span>
          </span>
        </span>
      </div>
    </div>
  );
};

export default JobColHeaderRenderer;
